<template>
  <v-progress-circular indeterminate :size="71" :width="7"></v-progress-circular>
</template>
